"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BaseAccordion =
/*#__PURE__*/
function (_Component) {
  _inherits(BaseAccordion, _Component);

  function BaseAccordion() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BaseAccordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BaseAccordion)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      openIndexes: []
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (index) {
      _this.internalSetState(function (state) {
        var closing = state.openIndexes.includes(index);
        return {
          type: closing ? "closing" : "opening",
          openIndexes: closing ? state.openIndexes.filter(function (i) {
            return i !== index;
          }) : [].concat(_toConsumableArray(state.openIndexes), [index])
        };
      });
    });

    return _this;
  }

  _createClass(BaseAccordion, [{
    key: "getState",
    value: function getState() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
      return {
        openIndexes: this.props.openIndexes === undefined ? state.openIndexes : this.props.openIndexes
      };
    }
  }, {
    key: "internalSetState",
    value: function internalSetState(changes) {
      var _this2 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var _this$props = this.props,
          onStateChange = _this$props.onStateChange,
          stateReducer = _this$props.stateReducer;
      var allChanges;
      this.setState(function (state) {
        var actualState = _this2.getState(state);

        var changesObject = typeof changes === "function" ? changes(actualState) : changes;

        if (stateReducer) {
          allChanges = stateReducer(actualState, changesObject);
        }

        return allChanges;
      }, function () {
        if (onStateChange) {
          onStateChange(allChanges);
        }

        callback();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        openIndexes: this.getState().openIndexes,
        handleItemClick: this.handleItemClick
      });
    }
  }]);

  return BaseAccordion;
}(_react.Component);

_defineProperty(BaseAccordion, "defaultProps", {
  onStateChange: function onStateChange() {},
  stateReducer: function stateReducer(state, changes) {
    return changes;
  }
});

var _default = BaseAccordion;
exports["default"] = _default;